import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    console.log('Accrual form connected')
  }

  updateFormWithAjax(event) {
    this.element.action = this.element.dataset.reloadUrl;
    this.element.method = 'get';
    this.submitTarget.click();
    // Dom extensions need to be re-run after this, but that is handled by accounting_accruals/reload_form.js.erb
  }
}